import cx from "classnames";
import React, { CSSProperties } from "react";
import styles from "./status-dot.module.scss";

export interface IStatusDot {
  status: "default" | "red" | "yellow" | "green" | "blue" | "white";
  description?: string;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const StatusDot = (props: IStatusDot) => {
  return (
    <span
      title={props.description}
      className={cx(
        styles.status_dot,
        props.status === "red" && styles.red,
        props.status === "yellow" && styles.yellow,
        props.status === "green" && styles.green,
        props.status === "blue" && styles.blue,
        props.status === "white" && styles.white,
        props.className
      )}
      style={props.style}
      id={props.htmlId}
    />
  );
};

StatusDot.defaultProps = {};
